$(document).ready(function () {
	let $inputBuyTechUserItem = $('#buy-tech-user-item');

	if ($inputBuyTechUserItem) {
		let placeholderDesktop = $inputBuyTechUserItem.data('placeholder-desktop'),
			placeholderMobile = $inputBuyTechUserItem.data('placeholder-mobile');

		if ($(window).width() < 768) {
			$inputBuyTechUserItem.attr('placeholder', placeholderMobile)
		} else {
			$inputBuyTechUserItem.attr('placeholder', placeholderDesktop)
		}
	}
});
